/**
 * Match Heights Utility
 * Matches the heights of internal blocks with the same data-block-id 
 * across product cards located in the same visual row.
 */

function matchInternalBlockHeights() {
  const productCards = Array.from(document.querySelectorAll('.product-card[data-match-internal-blocks-height="true"]'));
  
  if (productCards.length === 0) return;

  // Clear previous inline min-heights to allow elements to shrink naturally before measuring
  productCards.forEach(card => {
    const blocks = card.querySelectorAll('[data-block-id]');
    blocks.forEach(block => {
      block.style.removeProperty('min-height');
    });
  });

  // Group product cards by their visual row (using offsetTop)
  const rows = {};
  productCards.forEach(card => {
    // Add a slight tolerance (e.g., 10px) to account for subpixel differences
    // Use offsetTop because it is relative to the offsetParent and safer than getBoundingClientRect
    const top = Math.round(card.offsetTop / 10) * 10; 
    if (!rows[top]) rows[top] = [];
    rows[top].push(card);
  });

  Object.values(rows).forEach(rowCards => {
    if (rowCards.length <= 1) return; // No need to match heights if there's only 1 card in the row

    const blockHeights = {}; // { 'block-id-123': maxHeight }
    const blockElements = {}; // { 'block-id-123': [el1, el2, el3] }

    // First pass: Calculate maximum height for each block ID in this row
    rowCards.forEach(card => {
      const blocks = card.querySelectorAll('[data-block-id]');
      blocks.forEach(block => {
        const rawId = block.getAttribute('data-block-id');
        if (!rawId) return;
        
        // Shopify appends -1, -2, etc. to block IDs when rendering content_for 'blocks' in a loop.
        // We strip this suffix so all instances of the same block align correctly.
        const id = rawId.replace(/-\d+$/, '');

        const height = block.offsetHeight;
        
        if (!blockHeights[id] || height > blockHeights[id]) {
          blockHeights[id] = height;
        }

        if (!blockElements[id]) blockElements[id] = [];
        blockElements[id].push(block);
      });
    });

    // Second pass: Apply the maximum height to all instances in this row
    Object.keys(blockElements).forEach(id => {
      const maxHeight = blockHeights[id];
      blockElements[id].forEach(block => {
        block.style.minHeight = `${maxHeight}px`;
      });
    });
  });
}

function matchFaqGridHeaderHeights() {
  const containers = document.querySelectorAll('.faq-grid-container');
  
  containers.forEach(container => {
    const items = Array.from(container.querySelectorAll('.faq-grid-item'));
    if (items.length === 0) return;

    // Reset heights
    items.forEach(item => {
      const header = item.querySelector('.faq-grid-item-header');
      if(header) header.style.removeProperty('min-height');
    });

    // Group items by row (using offsetTop of the item)
    const rows = {};
    items.forEach(item => {
      const top = Math.round(item.offsetTop / 10) * 10;
      if (!rows[top]) rows[top] = [];
      rows[top].push(item);
    });

    // Apply max height to headers in each row
    Object.values(rows).forEach(rowItems => {
      if (rowItems.length <= 1) return;
      
      let maxHeight = 0;
      const headers = [];
      
      rowItems.forEach(item => {
        const header = item.querySelector('.faq-grid-item-header');
        if (header) {
          headers.push(header);
          const height = header.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        }
      });

      headers.forEach(header => {
        header.style.minHeight = `${maxHeight}px`;
      });
    });
  });
}

// Debounced wrapper
let matchHeightsTimeout;
function queueMatchHeights() {
  clearTimeout(matchHeightsTimeout);
  matchHeightsTimeout = setTimeout(() => {
    matchInternalBlockHeights();
    matchFaqGridHeaderHeights();
  }, 100);
}

// Global ResizeObserver to catch ANY layout changes (like images loading, fonts loading, etc.)
const resizeObserver = new ResizeObserver(() => {
  queueMatchHeights();
});

// Observe the main container (or body) to catch layout shifts
resizeObserver.observe(document.body);

// Also run on specific shopify events just in case
document.addEventListener('shopify:section:load', queueMatchHeights);
document.addEventListener('shopify:block:select', queueMatchHeights);
document.addEventListener('shopify:block:deselect', queueMatchHeights);

// Run immediately
queueMatchHeights();
